/*
  h26-closeup.js: LP "Every oil, up close" (sections/h26-lp-closeup.liquid). Loaded by the section.
  Every oil is already in the page (Liquid); this only switches which profile shows.
    shelf     role=tablist: click or tap a bottle; Left/Right/Home/End move and select (roving
              tabindex, aria-selected). The chosen bottle is kept in view inside the sideways
              phone shelf (never moves the page).
    prev/next [data-h26c-go] buttons under the profile: switch, focus the new name, and bring the
              profile top back on screen only when it has scrolled above the viewport.
    more      [data-h26c-more] (phone): opens/closes "More about {oil}" (aria-expanded).
    filled    an oil with no stock: "Closest taste: {oil}" points at the nearest available oil in
              the mild-to-bold order; the next add from that profile carries `_closest=1`.
  Events (window.OOH26.track, h26-events.js): oo_closeup_switch {product_id, from, method:
  shelf | shelf_key | arrow | closest}, oo_closeup_more_open {target}.
  window.OOH26C.show(productId, method) lets another section open an oil here (e.g. a picker).
*/
(function () {
  'use strict';
  if (window.OOH26C) return;

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function track(n, f, el) { try { if (window.OOH26 && window.OOH26.track) window.OOH26.track(n, f || null, el || null); } catch (e) {} }

  var ROOTS = [];

  function init(root) {
    if (!root || root.__h26c) return;
    root.__h26c = true;
    var shelf = root.querySelector('[data-h26c-shelf]');
    var tabs = $$('[data-h26c-tab]', root);
    var panels = $$('[data-h26c-panel]', root);
    if (!shelf || !tabs.length || !panels.length) return;
    var byId = {};
    panels.forEach(function (p) { byId[p.getAttribute('data-pid')] = p; });
    var on = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    var cur = on.getAttribute('data-pid');

    function tabFor(pid) { return tabs.filter(function (t) { return t.getAttribute('data-pid') === pid; })[0] || null; }

    function keepInShelf(tab) {
      if (!tab || shelf.scrollWidth <= shelf.clientWidth + 2) return;
      var l = tab.offsetLeft - shelf.offsetLeft;
      var r = l + tab.offsetWidth;
      var pad = 18;
      var target = null;
      if (l - pad < shelf.scrollLeft) target = Math.max(0, l - pad);
      else if (r + pad > shelf.scrollLeft + shelf.clientWidth) target = r + pad - shelf.clientWidth;
      if (target === null) return;
      try { shelf.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { shelf.scrollLeft = target; }
    }

    function closestFor(p) {
      var i = panels.indexOf(p);
      for (var d = 1; d < panels.length; d++) {
        var a = panels[i - d], b = panels[i + d];
        // equal distance: the milder one first (it sits earlier in the order)
        if (a && !a.hasAttribute('data-out')) return a;
        if (b && !b.hasAttribute('data-out')) return b;
      }
      return null;
    }

    function fillClosest() {
      panels.forEach(function (p) {
        if (!p.hasAttribute('data-out')) return;
        var btn = p.querySelector('[data-h26c-closest]');
        var none = p.querySelector('[data-h26c-closest-none]');
        if (!btn) return;
        var t = closestFor(p);
        if (t) {
          btn.textContent = String(btn.getAttribute('data-pattern') || '{oil}').replace(/\{oil\}/g, t.getAttribute('data-name') || '');
          btn.setAttribute('data-h26c-to', t.getAttribute('data-pid'));
          btn.setAttribute('data-h26-to', t.getAttribute('data-pid'));
          btn.hidden = false;
          if (none) none.hidden = true;
        } else {
          btn.hidden = true;
          if (none) none.hidden = false;
        }
      });
    }

    function show(pid, method, opts) {
      pid = String(pid || '');
      opts = opts || {};
      var p = byId[pid];
      if (!p) return false;
      if (pid === cur) return true;
      var from = cur;
      cur = pid;
      tabs.forEach(function (t) {
        var sel = t.getAttribute('data-pid') === pid;
        t.setAttribute('aria-selected', sel ? 'true' : 'false');
        t.tabIndex = sel ? 0 : -1;
        t.classList.toggle('is-on', sel);
      });
      panels.forEach(function (x) { x.hidden = x !== p; });
      p.classList.remove('is-pulse');
      void p.offsetWidth;
      p.classList.add('is-pulse');
      var tab = tabFor(pid);
      keepInShelf(tab);
      if (opts.focusTab && tab) { try { tab.focus({ preventScroll: true }); } catch (e) { tab.focus(); } }
      if (opts.focusHead) {
        var h = p.querySelector('.h26c-nm');
        if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      }
      if (opts.reveal) {
        var top = p.getBoundingClientRect().top;
        if (top < 0) { try { p.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { p.scrollIntoView(); } }
      }
      if (opts.closest) {
        var flag = p.querySelector('[data-h26c-closest-flag]');
        if (flag) flag.disabled = false;
      }
      track('closeup_switch', { product_id: pid, from: from, method: method || 'shelf' }, p);
      return true;
    }

    shelf.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-h26c-tab]');
      if (!t || !shelf.contains(t)) return;
      show(t.getAttribute('data-pid'), 'shelf');
    });

    shelf.addEventListener('keydown', function (e) {
      var t = e.target.closest && e.target.closest('[data-h26c-tab]');
      if (!t) return;
      var i = tabs.indexOf(t), j = -1;
      switch (e.key) {
        case 'ArrowRight': case 'Right': j = (i + 1) % tabs.length; break;
        case 'ArrowLeft': case 'Left': j = (i - 1 + tabs.length) % tabs.length; break;
        case 'Home': j = 0; break;
        case 'End': j = tabs.length - 1; break;
        default: return;
      }
      e.preventDefault();
      show(tabs[j].getAttribute('data-pid'), 'shelf_key', { focusTab: true });
    });

    root.addEventListener('click', function (e) {
      var go = e.target.closest && e.target.closest('[data-h26c-go]');
      if (go && root.contains(go)) {
        e.preventDefault();
        show(go.getAttribute('data-h26c-go'), go.getAttribute('data-via') || 'arrow', { focusHead: true, reveal: true });
        return;
      }
      var cl = e.target.closest && e.target.closest('[data-h26c-closest]');
      if (cl && root.contains(cl)) {
        e.preventDefault();
        show(cl.getAttribute('data-h26c-to'), 'closest', { focusHead: true, reveal: true, closest: true });
        return;
      }
      var mo = e.target.closest && e.target.closest('[data-h26c-more]');
      if (mo && root.contains(mo)) {
        var p = mo.closest('[data-h26c-panel]');
        if (!p) return;
        var open = mo.getAttribute('aria-expanded') !== 'true';
        mo.setAttribute('aria-expanded', open ? 'true' : 'false');
        p.classList.toggle('is-more', open);
        if (open) track('closeup_more_open', { target: p.getAttribute('data-pid') }, p);
      }
    });

    // a closest-taste add carries `_closest=1` once
    root.addEventListener('h26:atc', function (e) {
      var f = e.target && e.target.querySelector ? e.target.querySelector('[data-h26c-closest-flag]') : null;
      if (f) f.disabled = true;
    });

    fillClosest();
    root.__h26cShow = show;
    ROOTS.push(root);
  }

  function boot(scope) { $$('[data-h26c]', scope || document).forEach(init); }

  window.OOH26C = {
    init: boot,
    show: function (pid, method) {
      for (var i = 0; i < ROOTS.length; i++) {
        if (ROOTS[i].__h26cShow && ROOTS[i].__h26cShow(pid, method || 'external', { reveal: true })) return true;
      }
      return false;
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
